import { Pipe, PipeTransform } from "@angular/core";
import { EssTranslationService } from "ngx-essentia";

@Pipe({
    standalone: true,
    name: 'transMigrated',
})
export class TranslateMigratedPipe implements PipeTransform {
    private scopeMigrated = 'migrated';
    private cache = new Map<string, Promise<string>>();

    constructor(
        private essTrans: EssTranslationService,
    ) { }

    transform(keys: string): Promise<string> {
        let cached = this.cache.get(keys);
        if (!cached) {
            cached = this.essTrans.selectTranslate(keys, this.scopeMigrated);
            this.cache.set(keys, cached);
        }
        return cached;
    }
}
